<template>
  <ClientOnly>
    <article class="text-[#1F1F1F]">
      <div class="mb-20 flex w-full gap-5 max-md:flex-col max-md:gap-8">
        <WikiReadersChoice />
        <WikiNew />
      </div>
      <WikiPeriodsSlider class="mb-20" />
      <WikiContent />
    </article>
  </ClientOnly>
</template>

<script setup>
useHead(() => ({
  title:
    'История РФ: Российская историческая энциклопедия | Каталог | Справочник | История РФ',
  meta: [
    {
      name: 'description',
      content:
        'История Российской Федерации в статьях. Освещаем все вехи российской истории в статьях. Российское военно-историческое общество. Мы знаем правду.',
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: `${useHostApp()}/encyclopedia`,
    },
  ],
}));
</script>

<style lang="scss">
.link-item {
  @apply cursor-pointer transition-colors duration-300 hover:text-[#949494];
}
</style>
